import list from './list';
import declare from './declare';
import detail from './detail';
import departmentInitExamine from './departmentInitExamine';
import schoolInitExamine from './schoolInitExamine';
import alteration from './alteration';
import alterationExamine from './schoolAlterationExamine';
import complete from './complete';
import completeExamine from './completeExamine';
import departmentAlterationExamine from './departmentAlterationExamine';
import departmentCompleteExamine from './departmentCompleteExamine';


export default {
    list,
    declare,
    detail,
    departmentInitExamine,
    schoolInitExamine,
    alteration,
    alterationExamine,
    complete,
    completeExamine,
    departmentAlterationExamine,
    departmentCompleteExamine




}